export default __webpack_public_path__ + "static/media/select_down_arrow.cb72b63f.svg";